import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { GlobalAccount, GUID, OverdueHousehold, ServiceCadenceSnooze } from '@ndvr/customer-api';

import { CustomerApi } from 'API';
import { useSelectedTenantGUIDs } from 'views/auth/tenant-selection';
import { Toast } from 'widgets';

export const useFindHouseholdsWithoutRecentEvents = () => {
    const tenantGUIDs = useSelectedTenantGUIDs();

    return useQuery<OverdueHousehold[]>({
        queryKey: ['events', 'households', 'overdue', 'tenants', tenantGUIDs],
        queryFn: async () => {
            const [response] = await CustomerApi().findHouseholdsWithoutRecentEventsForTenants(tenantGUIDs);
            return response ?? [];
        },
        enabled: tenantGUIDs.length > 0,
    });
};

export const useCreateServiceCadenceSnooze = () => {
    const queryClient = useQueryClient();

    return useMutation<ServiceCadenceSnooze | undefined, unknown, GUID<GlobalAccount>>({
        mutationFn: async (householdGUID: GUID<GlobalAccount>) => {
            const [response] = await CustomerApi().createServiceCadenceSnooze(householdGUID);
            return response ?? undefined;
        },
        onSuccess: () => {
            Toast.success('Service cadence snoozed');
            queryClient.invalidateQueries({
                queryKey: ['events', 'households', 'overdue'],
            });
        },
        onError: (error) => {
            Toast.forError(error, 'Failed to snooze service cadence');
        },
    });
};
